import { Box, Flex } from '@chakra-ui/react'
import { Image } from '@/components/HOC/Image'
import DoubleBg from '@/public/assets/images/double/double-bg.png'
import { DoubleCounter } from '../atoms/DoubleCounter'
import { DoubleLastRolls } from '../molecules/DoubleLastRolls'
import { DoubleJackpot } from '../molecules/DoubleJackpot'
import { DoubleTrack } from '../molecules/DoubleTrack'
import { AnimatePresence, motion } from 'framer-motion'
import { RoundNumber } from '../../../atoms/RoundNumber/RoundNumber'
import { useDoubleStore } from '@/context/DoubleProvider'
import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'

export const DoubleRolling = () => {
  return (
    <>
      <Box h={{ base: 80, md: 96 }} rounded={'2xl'} pos={'relative'} overflow={'hidden'} mb={{ base: 2, md: 7 }}>
        <Image fill={'auto'} quality={90} objectFit="cover" priority={true} loading="eager" src={DoubleBg} alt={''} />
        <Flex
          justifyContent={'space-between'}
          flexDir={{ base: 'column', md: 'row' }}
          alignItems={'start'}
          gap={3}
          padding={6}
          pb={0}
          mb={{ base: 0, md: 6 }}
        >
          <DoubleJackpot />
          <DoubleLastRolls />
        </Flex>
        <DoubleTrackWrapper />
        <DoubleCounter />
        <DoubleRoundNumber />
      </Box>
    </>
  )
}

const DoubleTrackWrapper = () => {
  const previousRoll = useDoubleStore((x) => x.previousRoll)

  return previousRoll !== null ? <DoubleTrack /> : null
}

const DoubleRoundNumber = memo(() => {
  const { drawRoundTimestamp, drawRound } = useDoubleStore(
    useShallow((state) => ({
      drawRoundTimestamp: state.drawRoundTimestamp,
      drawRound: state.drawRound,
    }))
  )

  return (
    <Box pos={'absolute'} bottom={{ base: 4, md: 6 }} right={{ base: 4, md: 6 }}>
      <AnimatePresence>
        {drawRoundTimestamp && drawRound && (
          <motion.div key="DoubleRoundNumber" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <RoundNumber roundNumber={drawRound} date={new Date(drawRoundTimestamp).toLocaleString()} />
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  )
})
